import type { MedalTier } from "./assignMedalTiers";
import { medalScoreThresholds } from "./medalScoreThresholds";

const MEDAL_TIERS: readonly MedalTier[] = ["gold", "silver", "bronze"];

export function medalTierForScore(
  score: number,
  thresholds: Record<MedalTier, number | null>,
): MedalTier | null {
  for (const tier of MEDAL_TIERS) {
    if (thresholds[tier] === score) {
      return tier;
    }
  }
  return null;
}

export function projectedMedalTierForScore(
  score: number,
  thresholds: Record<MedalTier, number | null>,
): MedalTier | null {
  const projectedScores = [
    score,
    ...Object.values(thresholds).filter((threshold): threshold is number => threshold !== null),
  ]
    .sort((left, right) => left - right)
    .map((projectedScore) => ({ score: projectedScore }));
  return medalTierForScore(score, medalScoreThresholds(projectedScores));
}
